import React from 'react';
import '../styles/Values.css';

function Values({ language }) {
  const values = [
    {
      icon: 'fa-award',
      titleEN: 'Honesty',
      titleFR: 'Honnêteté',
      descEN: 'To act with uncompromising honesty and integrity in everything we do, remaining true to our commitments and communicating authentically.',
      descFR: 'Agir avec une honnêteté et une intégrité sans compromis dans tout ce que nous faisons, en restant fidèle à nos engagements et en communiquant avec authenticité.'
    },
    {
      icon: 'fa-handshake',
      titleEN: 'Transparency & Trust',
      titleFR: 'Transparence & Confiance',
      descEN: 'Honest communication, respect for commitments and transparent information sharing throughout our missions.',
      descFR: 'Communication honnête, respect des engagements et partage d\'information en toute sincérité tout au long de nos missions.'
    },
    {
      icon: 'fa-bolt',
      titleEN: 'Collaboration',
      titleFR: "Collaboration",
      descEN: 'Joining forces and working hand in hand with our customers to achieve excellence and deliver high-performance integration solutions.',
      descFR: "Unir nos forces et travailler main dans la main avec nos clients pour atteindre l'excellence et livrer des solutions d'intégration performantes."
    },
    {
      icon: 'fa-check-circle',
      titleEN: 'Responsibility & Commitment',
      titleFR: 'Responsabilité & Engagement',
      descEN: 'Complete management of our missions with proactive follow-up and total accountability for results.',
      descFR: 'Prise en charge complète de nos missions avec un suivi proactif et une accountability totale sur les résultats.'
    },
    {
      icon: 'fa-lightbulb',
      titleEN: 'Continuous Innovation',
      titleFR: 'Innovation Continue',
      descEN: 'Constant technology watch and adoption of the latest features to guarantee sustainable and scalable solutions.',
      descFR: 'Veille technologique constante et adoption des dernières fonctionnalités pour vous garantir des solutions pérennes et évolutives.'
    },
    
    {
      icon: 'fa-shield-alt',
      titleEN: 'Security & Compliance',
      titleFR: 'Sécurité & Conformité',
      descEN: 'Strict compliance with security standards (GDPR, ISO) and maximum protection of your sensitive data.',
      descFR: 'Respect rigoureux des normes de sécurité (RGPD, ISO) et protection maximale de vos données sensibles.'
    }
  ];

  return (
    <section id="values" className="values-section">
      <div className="container">
        <h2 className="section-title">
          <span lang="en">Our Values</span>
          <span lang="fr">Nos Valeurs</span>
        </h2>

        <p className="section-subtitle">
          <span lang="en">
            The principles that guide everything we do
          </span>
          <span lang="fr">
            Les principes qui guident tout ce que nous faisons
          </span>
        </p>

        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">
                <i className={`fas ${value.icon}`}></i>
              </div>
              <h3>
                <span lang="en">{value.titleEN}</span>
                <span lang="fr">{value.titleFR}</span>
              </h3>
              <p>
                <span lang="en">{value.descEN}</span>
                <span lang="fr">{value.descFR}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Values;
